import {useImoveisStore} from '../context/DataContext'
import {PivotTable} from './Performance/PivotTable'
import {Exportar} from '../partials/BtnExportar'

export function Performance() {
  const {imoveis} = useImoveisStore()
  const filtered = imoveis.filter((item) => item.active)

  return (
    <div className=' d-flex flex-column justify-content-start p-10' style={{height: '92.1vh'}}>
      <div className='header-report d-flex all-start-between '>
        <div>
          <h1 className='fw-bolder'>Tabela de Dinâmica</h1>
          <span>Imóveis anunciados nos ultimos 60 dias.</span>
        </div>
        <div>
          <Exportar data={imoveis}></Exportar>
        </div>
      </div>
      <div className='content pt-10'>
        <div className=' g-5 g-xl-8'>
          <div className='card mb-6'>
            <div className='card-body'>
              <div className='row'>
                <PivotTable itens={filtered}></PivotTable>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
